import Vue from 'vue';
import Router from 'vue-router';
import ScaffoldForm from './scaffold/form/scaffold-form';
import Builder from './builder/builder';
import RelationshipForm from './builder/relationship/relationship-form';
import EntityForm from './builder/entity/entity-form';
import FieldForm from './builder/field/field-form';
import Simulator from './builder/simulator/simulator';
import ProjectPreview from './project/project-preview';
import ProjectDownload from './project/project-download';
import ProjectList from './project/project-list';
import AuthSignIn from './auth/auth-sign-in';
import AuthForgotPassword from './auth/auth-forgot-password';
import AuthAccount from './auth/auth-account';
import Affiliate from './affiliate/affiliate';
import Pricing from './pricing/pricing';
import PurchaseCancel from './purchase/purchase-cancel';
import PurchaseSuccess from './purchase/purchase-success';
import NotFound from './core/not-found';
import config from './config';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: config.BASE_URL,
  routes: [
    { path: '/', redirect: '/scaffold/nodejs' },
    {
      name: 'authSignIn',
      path: '/auth/sign-in',
      component: AuthSignIn,
    },
    {
      name: 'authForgotPassword',
      path: '/auth/forgot-password',
      component: AuthForgotPassword,
    },
    {
      name: 'authAccount',
      path: '/auth/account',
      component: AuthAccount,
    },
    {
      name: 'pricing',
      path: '/pricing',
      component: Pricing,
    },
    {
      name: 'projects',
      path: '/project',
      component: ProjectList,
    },
    {
      name: 'affiliate',
      path: '/affiliate',
      component: Affiliate,
    },
    {
      name: 'project-preview',
      path: '/project/:projectId',
      component: ProjectPreview,
      props: true,
    },
    {
      name: 'project-download',
      path: '/project/:projectId/download',
      component: ProjectDownload,
      props: true,
    },
    {
      name: 'scaffold-new',
      path: '/scaffold/new',
      component: ScaffoldForm,
    },
    {
      name: 'scaffold-edit',
      path: '/scaffold/:scaffoldId/edit',
      component: ScaffoldForm,
      props: true,
    },
    {
      name: 'purchase-success',
      path: '/purchase/success',
      component: PurchaseSuccess,
      props: true,
    },
    {
      name: 'purchase-cancel',
      path: '/purchase/cancel',
      component: PurchaseCancel,
      props: true,
    },
    {
      name: 'simulator',
      path: '/scaffold/simulator',
      component: Simulator,
    },
    {
      name: 'builder',
      path: '/scaffold/:scaffoldId',
      component: Builder,
      props: true,
    },
    {
      name: 'entity-new',
      path: '/scaffold/:scaffoldId/entity/new',
      component: EntityForm,
      props: true,
    },
    {
      name: 'relationship-new',
      path: '/scaffold/:scaffoldId/relationship/new',
      component: RelationshipForm,
      props: true,
    },
    {
      name: 'entity-edit',
      path: '/scaffold/:scaffoldId/entity/:id/edit',
      component: EntityForm,
      props: true,
    },
    {
      name: 'relationship-edit',
      path: '/scaffold/:scaffoldId/relationship/:id/edit',
      component: RelationshipForm,
      props: true,
    },
    {
      name: 'field-new',
      path:
        '/scaffold/:scaffoldId/entity/:entityId/field/new',
      component: FieldForm,
      props: true,
    },
    {
      name: 'field-edit',
      path:
        '/scaffold/:scaffoldId/entity/:entityId/field/:id/edit',
      component: FieldForm,
      props: true,
    },
    {
      path: '*',
      component: NotFound,
    },
  ],
});
